// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDZbXANFA7xzjH-XC5_hi7Ez3nnFMpfTiQ",
  authDomain: "expense-tracker-f80d4.firebaseapp.com",
  projectId: "expense-tracker-f80d4",
  storageBucket: "expense-tracker-f80d4.appspot.com",
  messagingSenderId: "881886174972",
  appId: "1:881886174972:web:a3ada898917f53d8be0179"
};

// Initialize Firebase
initializeApp(firebaseConfig);

export const db = getFirestore();
export const projectAuth = getAuth();
export const provider = new GoogleAuthProvider();
